import * as React from "react";
import {useIntl} from "react-intl";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/pro-solid-svg-icons";
import {BLOCK_TYPES, BlockType} from "../../types/emailBlocks";

interface BlockPaletteProps {
    onAddBlock: (type: BlockType) => void;
}

const BlockPalette: React.FC<BlockPaletteProps> = ({onAddBlock}) => {
    const intl = useIntl();

    return (
        <div className="p-3 border-b border-gray-200 bg-gray-50">
            <div className="flex gap-3">
                {BLOCK_TYPES.map((blockType) => (
                    <button
                        key={blockType.type}
                        type="button"
                        onClick={() => onAddBlock(blockType.type)}
                        className="relative flex items-center justify-center w-14 h-12 bg-white border border-gray-200 rounded-lg hover:border-red-300 hover:bg-red-50 transition-colors group"
                        title={intl.formatMessage({id: blockType.labelKey})}
                    >
                        <FontAwesomeIcon
                            icon={blockType.icon}
                            className="w-5 h-5 text-gray-500 group-hover:text-red-600"
                        />
                        <span className="absolute top-1 right-1">
                            <FontAwesomeIcon
                                icon={faPlus}
                                className="w-2.5 h-2.5 text-gray-400 group-hover:text-red-500"
                            />
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default BlockPalette;
